const ColdPackPlugin = {
    config: {
        cartAddUrl: "/cart/add",
        helpSensitiveTag : window.theme.strings.cart_cold_pack_heattag,
        coldServiceProductHandle: 'your_cold_service_handle',
        coldServiceAmountThreshold: 10,
        coldServiceNoticeSelector: '.rebuy-cart__flyout-integration #coldnoticebutton',
        coldServiceNoticeText: 'Your order contains heat-sensitive items...',
        cartUpdateUrl: '/cart/update.js',
        cartChangeUrl: '/cart/change.js',
        ipLookupUrl: 'https://appbundle.bariatricpal.com/Home/iplookupmain',
        cart_cold_service_enable: window.theme.strings.cart_cold_service_enable,
        cart_cold_service_product_handle: window.theme.strings.cart_cold_service_product_handle,
        cart_cold_service_product_vid: window.theme.strings.cart_cold_service_product_vid,
        cart_cold_allowedstateabb: window.theme.strings.cart_cold_allowedstateabb,
        IsColdPackSbbAllowed: window.theme.strings.IsColdPackSbbAllowed,
        IsColdPackSbbAllowedDefault: window.theme.strings.IsColdPackSbbAllowedDefault,
        CustomerDefaultStateAbb: window.theme.strings.CustomerDefaultStateAbb,
        cart_cold_service_amount: window.theme.strings.cart_cold_service_amount,
    },
    addCartColdPackButtonHtml: function(){
          
                // Find the target container and create the new element
          const footerContainer = document.querySelector('.rebuy-cart__flyout-footer');
          const newElement = document.createElement('div');
          newElement.className = 'rebuy-cart__flyout-integration';
          
          // Append the new element as the first child of the footer container
          if (footerContainer) {
            footerContainer.insertBefore(newElement, footerContainer.firstChild);
          }
          
                
                // Create the HTML structure
          const newDiv = document.createElement('div');
          newDiv.id = 'coldnoticebutton';
          newDiv.className = 'mehidden';
          
          // Append the newDiv to the existing div with class 'rebuy-cart__flyout-integration'
          const parentDiv2 = document.querySelector('.rebuy-cart__flyout-integration');
          parentDiv2.appendChild(newDiv);
          
          
          
          
          
          // Create the <a> element
          const newLink = document.createElement('a');
          newLink.setAttribute('onclick', 'return window.ColdPackPlugin.addColdPackServiceInCart(true)');
          newLink.setAttribute('data-tooltip', 'Your order contains heat-sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. If you decline cold pack service you accept the risk of heat-damaged products.');
          newLink.className = 'rebuy-button block';
          newLink.style.background = '#d44b3c';
          newLink.style.borderColor = '#d44b3c';
          newLink.style.cursor = 'pointer';
          newLink.setAttribute('data-uw-rm-kbnav', 'click');
          newLink.textContent = 'Add Cold Pack Service';
          
          // Append the newLink to the existing div with id 'coldnoticebutton'
          const parentDiv1 = document.getElementById('coldnoticebutton');
          parentDiv1.appendChild(newLink);
      
    },
    checkColdPackStates: async function () {
        console.log('before start');
        // Set local variable for state allowed for ColdPack service.
        var geoLoc = await this.ipLocationCall();        
        if ((geoLoc.country_code == "US" && (this.config.cart_cold_allowedstateabb.includes(geoLoc.province_code))) ||
            (geoLoc.country_code != "US" && this.config.cart_cold_allowedstateabb.includes('XX')) || (geoLoc.province_code == null)) {
            console.log(geoLoc.province_code);
            this.config.IsColdPackSbbAllowed = true;
        } else {
            this.config.IsColdPackSbbAllowed = false;
        }
        console.log('after start');
    },
  
    ipLocationCall : async function () {
        // Used to call internal ip geo location detection service.
        var cntObj = {};
        if (localStorage.getItem("ciplookup") != null) {
            cntObj = JSON.parse(localStorage.getItem("ciplookup"));
        } else {
            await fetch(this.config.ipLookupUrl).then(s => s.json()).then(s => {
                cntObj = s
            });
            localStorage.setItem("ciplookup", JSON.stringify(cntObj));
        }
        return {
            country_code: cntObj.countryCode,
            province_code: cntObj.region
        }
    },
    updateCartAttributeColdPackRemoved : function (parAction) {
        var addData = {
            'attributes': {
                '_COLDPACK': 'CUSTOMER ' + parAction
            }
        };
        fetch(this.config.cartUpdateUrl, {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        }).then(function(response) {
            return response.json();
        }).then(function(json) {
            /* we have JSON */
            console.log("---- COLD-SERVICE ATTRIBUTE EXECUTED " + parAction, json)
            window.cartattributeupdate = true;
        }).catch(function(err) {
            /* uh oh, we have error. */
            console.error(err)
        });
    }
    ,
    addColdServiceNoticeToDrawer: function () {

        if(document.querySelector(window.ColdPackPlugin.config.coldServiceNoticeSelector) == null){
          window.ColdPackPlugin.addCartColdPackButtonHtml();
        }
        /*--  coldnoticebutton div is placed in Rebuy SAMRT Cart Widget, only visible based on below code -- */
        document.querySelector(window.ColdPackPlugin.config.coldServiceNoticeSelector).classList.remove("mehidden");
        /*<div id="coldnoticebutton">
		<a data-tooltip="Your order contains heat-sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. If you decline cold pack service you accept the risk of heat-damaged products." class="rebuy-button block" title="Your order contains heat sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. " style="background: #d44b3c;border-color: #d44b3c;cursor: pointer;"> Add Cold Pack Service - $3.99</a> 
	</div>*/
    }

    ,removeColdServiceNoticeToDrawer: function () {
        if (document.querySelector(window.ColdPackPlugin.config.coldServiceNoticeSelector) != null)
            document.querySelector(window.ColdPackPlugin.config.coldServiceNoticeSelector).classList.add("mehidden");
    }

    ,addColdPackServiceInCart: function (forceAdd) {
        setCookie("coldserviceadded" + Rebuy.Cart.cart.token, 1);
        var addData = {
            'id': window.ColdPackPlugin.config.cart_cold_service_product_vid,
            'quantity': 1,
            'properties': {
                '_Offer': 'FREE'
            }
        };
        fetch(window.ColdPackPlugin.config.cartAddUrl + '.js', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
            },
            method: 'POST'
        }).then(function(response) {
            return response.json();
        }).then(function(json) {
            /* we have JSON */
            console.log("---- HEAT SENSITIVE COLD-SERVICE ADDED", json)
            setCookie("csautoadd" + Rebuy.Cart.cart.token, 1);
            if (forceAdd == true) {
                window.ColdPackPlugin.removeColdServiceNoticeToDrawer();
                window.cartattributeupdate = true;
                window.ColdPackPlugin.updateCartAttributeColdPackRemoved("ADDED");
            }
            document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
                bubbles: true
            }));
        }).catch(function(err) {
            /* uh oh, we have error. */
            console.error(err)
            document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
                bubbles: true
            }));
        });
        return false;
    }

    ,heatSensitiveService: function(forceAdd) {
        this.removeColdServiceNoticeToDrawer();
        var itmttl = 0;
        var atleastonefound = false;
        window.coldpackrequire = false; // used only in this method.
        if (this.config.IsColdPackSbbAllowed == false) {
            return;
        }
        window.Rebuy.Cart.getItems().forEach(function(p, index) {
            var phandle = p.handle;
            fetch("/products/" + phandle + ".json").then(s => s.json()).then(function(data) {
                itmttl++;
                if (data.product.tags.includes(window.ColdPackPlugin.config.helpSensitiveTag)) {
                    window.coldpackrequire = true;
                    setCookie("coldservicerequired", 1);
                    var yesExists = window.Rebuy.Cart.getItems().find(s => s.handle == window.ColdPackPlugin.config.cart_cold_service_product_handle);
                    if (yesExists != null) {
                        setCookie("coldserviceadded" + Rebuy.Cart.cart.token, 1);
                        window.ColdPackPlugin.removeColdServiceNoticeToDrawer();
                    } else if (forceAdd != true && forceAdd != null && getCookie("coldserviceadded" + Rebuy.Cart.cart.token) == "1") {
                        // Customer intensionally removed this cold pack item. So add RED button again.
                        // add div to rebuy drawer.
                        window.ColdPackPlugin.addColdServiceNoticeToDrawer();
                        window.ColdPackPlugin.updateCartAttributeColdPackRemoved("REMOVED");
                        setCookie("coldserviceadded" + Rebuy.Cart.cart.token, 0);
                    } else {
                        setCookie("coldserviceadded" + Rebuy.Cart.cart.token, 0);
                        // add div to rebuy drawer.
                        window.ColdPackPlugin.addColdServiceNoticeToDrawer();
                    }
                    if (getCookie("csautoadd" + Rebuy.Cart.cart.token) == "1" && forceAdd != true) {
                        return;
                    }
                    var ctotal = window.Rebuy.Cart.subtotal() / 100;
                    if ((forceAdd == true || parseFloat(window.ColdPackPlugin.config.cart_cold_service_amount) <= ctotal) && (getCookie("coldserviceadded" + Rebuy.Cart.cart.token) != "1") &&
                        yesExists == null && atleastonefound == false) {
                        atleastonefound = true; // so that Adding cold pack will execute ONE time in Loop of Cart Line items
                        // Yes cart have heat sensitive item, add extra service product. 
                        window.ColdPackPlugin.addColdPackServiceInCart();
                        window.ColdPackPlugin.removeColdServiceNoticeToDrawer();
                    }
                }
                if (itmttl == window.Rebuy.Cart.getItems().length && window.coldpackrequire == false &&
                    getCookie("coldserviceadded" + Rebuy.Cart.cart.token) == "1") {
                    // COLD SHOT NOT REQUIRED. & PREENT IN CART. SO REMOVE IT.
                    var removeData = {
                        'id': window.ColdPackPlugin.config.cart_cold_service_product_vid,
                        'quantity': 0
                    };
                    fetch(window.ColdPackPlugin.config.cartChangeUrl, {
                        body: JSON.stringify(removeData),
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'xmlhttprequest'
                        },
                        method: 'POST'
                    }).then(s => s.json()).then(function(data) {
                        window.cartattributeupdate = true;
                        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged'));
                    });
                }
            });
        })
        return true;
    }
};
// Initialize the Cold Pack Plugin
ColdPackPlugin.checkColdPackStates();
  
// Export the plugin globally if needed
window.ColdPackPlugin = ColdPackPlugin;

document.addEventListener('rebuy:cart.change', function(event){
  setTimeout(function(){

    document.documentElement.dispatchEvent(
      new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false })
    );
    
            if(window.cartattributeupdate != true){
                //console.log("is wholesale customer heatsnsitive fired");
            	window.ColdPackPlugin.heatSensitiveService();
            }else{
              window.cartattributeupdate = false;
            }
  },300);
});

theme.yotpoRefresh = function() {
    //yotpo.refreshWidgets()
}

function setCookie(n, t, i) {
    var r = new Date, u;
    r.setHours(r.getHours() + i);
    u = escape(t) + (i == null ? "" : "; expires=" + r.toUTCString());
    document.cookie = n + "=" + u + "; path=/"
}
function getCookie(n) {
    var t = document.cookie, i = t.indexOf(" " + n + "="), r;
    return i == -1 && (i = t.indexOf(n + "=")),
    i == -1 ? t = null : (i = t.indexOf("=", i) + 1,
    r = t.indexOf(";", i),
    r == -1 && (r = t.length),
    t = unescape(t.substring(i, r))),
    t
}


function bindReviewsClickProductpage(){
  if(document.querySelector(".product-detail .yotpo-reviews-star-ratings-widget.yotpo-star-ratings-clickable") == null){
    setTimeout(bindReviewsClickProductpage,2000);
    return;
  }
  document.querySelector(".product-detail .yotpo-reviews-star-ratings-widget.yotpo-star-ratings-clickable").addEventListener("click", function(e){
        document.querySelector(".shopify-block.shopify-app-block .yotpo.yotpo-main-widget").scrollIntoView({ behavior: 'smooth' });
  });
  
}

(function(){
  if(document.body.classList.contains("template-product")){
    bindReviewsClickProductpage();
  }
})();








/* Using a self-executing anonymous function - (function(){})(); - so that all variables and functions defined within 
aren’t available to the outside world. */

(function(){
  
/* Load Script function we may need to load jQuery from the Google's CDN */
/* That code is world-reknown. */
/* One source: http://snipplr.com/view/18756/loadscript/ */

var loadScript = function(url, callback){
 
  var script = document.createElement("script");
  script.type = "text/javascript";

  // If the browser is Internet Explorer.
  if (script.readyState){ 
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" || script.readyState == "complete"){
        script.onreadystatechange = null;
        callback();
      }
    };
  // For any other browser.
  } else {
    script.onload = function(){
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
    
};

/* This is my app's JavaScript */
var myAppJavaScript = function($){
  // $ in this scope references the jQuery object we'll use.
  // Don't use jQuery, or jQuery191, use the dollar sign.
  // Do this and do that, using $.
  
  //$('body').append('<p>Your app is using jQuery version '+$.fn.jquery+'</p>');
  
  
 //Build a pseudo-class to prevent polluting our own scope.
	var api = {
		Settings: {
          IsProp65Enable : true,
          Prop65Tag : "prop65",          
          iplookdomain :"https://geoip.sezzle.com/v1/geoip/ipdetails",
          StateProvinceKey : "state" + new Date().getDate() + new Date().getMonth() + new Date().getFullYear(),
          CartData: null,
        },
      	IpLookUpOutsideService : function(){
      	
          if(typeof Rebuy == "object" && typeof Rebuy.getGeolocation == "function"){
          	Rebuy.getGeolocation().then(res => {
                console.log(res);
              var json = res; 
              json.country = res.country_name;
              json.city = res.city_name;
              json.region = res.province_name;
              json.state_prov = res.province_name;
              
              if (json.country && json.city) {
                           if(json.city.toLowerCase() == "california"){
                           		window["MyStoreWidget"].warningForCalifornizaCelebrateProducts(json.city);
                           }
                           else if(json.region == "California"){
                           		window["MyStoreWidget"].warningForCalifornizaCelebrateProducts(json.region);
                           }else if(json.state_prov == "California"){
                           		window["MyStoreWidget"].warningForCalifornizaCelebrateProducts(json.state_prov);
                           }
                         }
              
            }, failure => {
                console.error(failure); //expected output: Oopsy...
            })
          }
          else{
            
            if(localStorage.getItem(window["MyStoreWidget"].Settings.StateProvinceKey) == undefined){

      				$.getJSON(window["MyStoreWidget"].Settings.iplookdomain,
                        function(json) {

                          if(json.country_iso_code && json.city){                            	
                                if(json.city.toLowerCase() == "california" || json.region_name.toLowerCase() == "california"){
                                  	localStorage.setItem(window["MyStoreWidget"].Settings.StateProvinceKey,"california");
                                    window["MyStoreWidget"].warningForCalifornizaCelebrateProducts("california");
                                }else{
                                	localStorage.setItem(window["MyStoreWidget"].Settings.StateProvinceKey,json.region_name.toLowerCase());
                                }
                          }
              			
                  	});
            }else if(localStorage.getItem(window["MyStoreWidget"].Settings.StateProvinceKey) == "california"){
            	window["MyStoreWidget"].warningForCalifornizaCelebrateProducts("california");
            }
          }
      	},
      	showCaliforniaCustomerWarning : function(){
          
          	window["MyStoreWidget"].IpLookUpOutsideService();
          	return;
             
        },
      	warningForCalifornizaCelebrateProducts : function(province) {
          	if(province != null && (province.toLowerCase() == "california")){
                var msg='<div id="warning-celebrate"><b><img src="https://cdn.shopify.com/s/files/1/0806/1189/files/warningicon.png?v=1715173312" class="img-prop65warning"/>WARNING: California\'s Proposition 65:</b> Consuming this product can expose you to chemicals including lead, which is known to the State of California to cause cancer and birth defects or other reproductive harm.  For more information go to <a target="_blank" href="https://www.P65Warnings.ca.gov/food">www.P65Warnings.ca.gov/food.</a></div>';
                // add this message for california based visitor and Celebrate Vitamins brand products.
                $(".product-description").append(msg);

                if($("body").hasClass("cart")){  
                  if($("#warning-celebrate").length == 0){
                  	msg='<div id="warning-celebrate" style="max-width:90%;margin:0px auto 10px auto;" ><div><b><img src="https://cdn.shopify.com/s/files/1/0806/1189/files/warningicon.png?v=1715173312" class="img-prop65warning"/>WARNING: California\'s Proposition 65:</b> Consuming these products can expose you to chemicals including lead, which is known to the State of California to cause cancer and birth defects or other reproductive harm. For more information go to <a href="https://www.P65Warnings.ca.gov/food" target="_blank">www.P65Warnings.ca.gov/food</a>.</div></div>';
                    $("footer").prepend(msg);
                  }
                }
            }  
      	},
      	IsCorrectPlaceForProp65 : function(){
      		// If product page, Cart page or Checkout page.
          if(window.location.href.indexOf("/products") > -1){
          	return true;
          }else if(window.location.href.indexOf("/cart") > -1){
          	return true;
          }else if(window.location.href.indexOf("/checkout") > -1){
          	return true;
          }
          return false;
      	},
      	Prop65TagProcessStart: function(){

          if(window["MyStoreWidget"].IsCorrectPlaceForProp65()){
            
          	// Check products Tags and based on it, Display PROP65 related message.
            if(window.location.href.indexOf("/products") > -1){  
              var tempu = window.location.href.toString().replace(window.location.search,"");
				
              $.getJSON(tempu+".json",function(r){ var e = window["MyStoreWidget"].CheckTagsOfProduct(r); 
                                                         if(e){  
                                                           
              		window["MyStoreWidget"].AddProp65Message("p");
              	} });
            }else if(window.location.pathname.includes("/cart")){
              $.getJSON("/cart.json",function(ct){ 
                	// Whole Cart. check Items
                	var onceDisplayed=false;
                	$(ct.items).each(function(index,item){
                      	var tempurl = item.url.split("?")[0];
                      	// Get product details, check tags.                      	
                      	$.getJSON(tempurl+".json",function(r){ 
                          		
                                var e1 = window["MyStoreWidget"].CheckTagsOfProduct(r); 
                          		if(e1 == true) { 
                                  if(onceDisplayed == false){
                                    window["MyStoreWidget"].AddProp65Message("c"); 
                                  }
                                  onceDisplayed = true;
                                }
                                                      	
                        });
                	});
                
                                                   
				});
            }
          	
          }
          
      	},
      	AddProp65Message : function(pagetype){
          if(pagetype == "p" || pagetype == "c"){
          		// product page message.
            	
            	window["MyStoreWidget"].showCaliforniaCustomerWarning();
          }
      	},
      	CheckTagsOfProduct : function(pobj){ 
      		var tags = pobj.product.tags.split(",");
          
          	var exists = false; 
              tags.filter(function(item,index){ 
            	if($.trim(item).toLowerCase() == window["MyStoreWidget"].Settings.Prop65Tag){
          			exists=true;
          		} 
          	});
          	
          	return exists;
      	},
      	Start: function () {
          
		}
	};

  	//Optionally make the api available to the global scope for debugging.
	window["MyStoreWidget"] = api;
  
  	if(window["MyStoreWidget"].Settings.IsProp65Enable){
  		window["MyStoreWidget"].Prop65TagProcessStart();
  	}
  
	//Optionally make the api available to the global scope for debugging.
	window["MyStoreWidget"] = api;
  
};

/* If jQuery has not yet been loaded or if it has but it's too old for our needs,
we will load jQuery from the Google CDN, and when it's fully loaded, we will run
our app's JavaScript. Set your own limits here, the sample's code below uses 1.7
as the minimum version we are ready to use, and if the jQuery is older, we load 1.9. */
if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    myAppJavaScript(jQuery191);
  });
} else {
  myAppJavaScript(jQuery);
}

})();


// For Accesibility link footer
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    var originalEl = document.querySelector('#beaa');
    if (originalEl) {
      var parentDiv = originalEl.closest('div');
      if (parentDiv) {
        // Clone the original element
        var clone = originalEl.cloneNode(true);

        // Hide the original
        originalEl.style.display = 'none';

        // Insert the clone after the parent div
        parentDiv.insertAdjacentElement('afterend', clone);

        // On clone click, trigger original click
        clone.addEventListener('click', function (e) {
          e.preventDefault(); // Prevent default navigation on clone
          originalEl.click();
        });
      }
    }
  }
});


function openNotifyFormForThisProduct(el) {
  const popup = document.getElementById("notify-form-product");

  // Set product and variant ID
  const productId = el.getAttribute("data-productid");
  const variantId = el.getAttribute("data-vid");

  let productTitle = el.closest(".buy-product-container-2").querySelector(".product-block__title").innerText;
  document.querySelector("div#notify-form-product .responseMsg").innerHTML = "";
  
  const notifyBox = popup.querySelector(".notify-custom");
  notifyBox.setAttribute("data-pid", productId);
  notifyBox.setAttribute("data-vid", variantId);

  popup.querySelector("#notifyProductTitle").innerText = productTitle;

  // Show the popup
  popup.classList.add("show");
  popup.style.display = "flex";
}
function closeNotifyPopup() {
  const popup = document.getElementById("notify-form-product");
  popup.classList.remove("show");
  popup.style.display = "none";
}

document.addEventListener("DOMContentLoaded", function () {
    // Optional: Close when clicking outside
    document.addEventListener("click", function (e) {
      const popup = document.getElementById("notify-form-product");
      if(popup != null){
        if (popup.classList.contains("show") && !popup.querySelector(".notify-custom").contains(e.target) && !e.target.closest(".klaviyo-bis-trigger")) {
          popup.classList.remove("show");
          popup.style.display = "none";
        }
      }
    });

    document.querySelectorAll(".buy-product-container-2 a.button.klaviyo-bis-trigger")
  .forEach(function(btn) {
    btn.addEventListener("click", function () {
      openNotifyFormForThisProduct(this);
    });
  });

});

function buttonSubmitNotifyMeKlaviyo(ctrl)
{
  	
        var ctrl = event.target; // or pass `ctrl` explicitly to this function
        var pdiv = ctrl.closest(".notify-custom");
        var klvkey = "WxEZMj";

        var emailInput = pdiv.querySelector("#txtEmail");
        var cemail = emailInput ? emailInput.value.trim() : "";

        var variantid = pdiv.getAttribute("data-vid");

        if (cemail === "") {
          var modal = document.querySelector("div#notify-form-product");
          if (modal) {
            var responseMsg = modal.querySelector("div#notify-form-product .responseMsg");
            if (responseMsg) {
              responseMsg.innerHTML = "Please enter email address.";
            }
          }
          return false;
        }

        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + klvkey, {
            method: "POST",
            mode: "cors",
            credentials: "omit",
            referrer: window.location.origin + "/",
            referrerPolicy: "strict-origin-when-cross-origin",
            headers: {
              "accept": "application/json",
              "accept-language": "en-US,en;q=0.9",
              "content-type": "application/json",
              "priority": "u=1, i",
              "revision": "2024-02-15",
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "cross-site",
              "x-klaviyo-onsite": "1"
            },
            body: JSON.stringify({
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: cemail
                      }
                    }
                  },
                  channels: ["EMAIL"]
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      id: "$shopify:::$default:::" + variantid
                    }
                  }
                }
              }
            })
          })
          .then(response => {
            const el = document.querySelector("div#notify-form-product .responseMsg");
            if (response.status === 200 || response.status === 202) {
              el.innerHTML = "Thanks! You will get a notification when it's back in stock.";
            } else {
              el.innerHTML = "There was something wrong with your request. Please try later.";
            }
          })
          .catch(error => {
            console.error(error);
            const el = document.querySelector("div#notify-form-product .responseMsg");
            if (el) {
              el.innerHTML = "Alert service down. Sorry for any Inconvenience.";
            }
          });
  
}

/* // smooth scroll to anchor, with option of hash appearing in url.
$(document).ready(function(){
  $('a[href^="#"]').on('click',function (e) {
      e.preventDefault();
      var target = this.hash;
      var $target = $(target);
      $('html, body').stop().animate({
          'scrollTop': $target.offset().top
      }, 900, 'swing', function () {
          // window.location.hash = target;
      });
  });
}); */

$(document).ready(function(){
  $('a[href^="#"]').on('click', function (e) {
    var target = this.hash;
    var $target = $(target);

    if ($target.length && target !== '#') {
      e.preventDefault();
      $('html, body').stop().animate({
        scrollTop: $target.offset().top
      }, 900, 'swing');
    }
    // else: let it pass through, don't animate
  });


    bindSmartCartLink();

});

// Function to handle the fallback logic
function bindFallbackLink() {
  const cartTrigger = document.querySelector('#smartCartTrigger');
  if (cartTrigger) {
    cartTrigger.href = '/cart';
    cartTrigger.target = '_self'; 
    console.log('Rebuy.SmartCart is not available. Redirecting to /cart.');
  } else {
    console.warn('#smartCartTrigger element not found. Cannot set fallback link.');
  }
}

// Main logic to bind the link or apply the fallback
function bindSmartCartLink() {
  const maxWaitTime = 15000; // 10 seconds
  const checkInterval = 1000; 
  let timeElapsed = 0;

  const checkAvailability = setInterval(() => {
    
    if (typeof Rebuy !== 'undefined' && typeof Rebuy.SmartCart !== 'undefined' && typeof Rebuy.SmartCart.show === 'function') {
      clearInterval(checkAvailability);
      document.querySelector('#smartCartTrigger').addEventListener('click', (event) => {
        event.preventDefault(); // Prevent the default link behavior
        Rebuy.SmartCart.show();
      });
      console.log('Rebuy.SmartCart is available. Event listener bound.');

      setTimeout(() => {
        document.querySelector('#smartCartTrigger').addEventListener('click', (event) => {
          event.preventDefault(); // Prevent the default link behavior
          Rebuy.SmartCart.show();
        });
        console.log('RETRY Rebuy.SmartCart is available. Event listener bound.');

      }, 2000); 

    } else {
      timeElapsed += checkInterval;
      if (timeElapsed >= maxWaitTime) {
        clearInterval(checkAvailability);
        bindFallbackLink();
      }
    }
  }, checkInterval);
}


